/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/globe'
export default icon
